(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("mobx"), require("react-dom"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "mobx", "react-dom", "moment"], factory);
	else if(typeof exports === 'object')
		exports["choerodon-ui-with-locales.min"] = factory(require("react"), require("mobx"), require("react-dom"), require("moment"));
	else
		root["choerodon-ui-with-locales.min"] = factory(root["React"], root["mobx"], root["ReactDOM"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__28__, __WEBPACK_EXTERNAL_MODULE__41__) {
return 